import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ContactDetailsFormProps } from '@src/models/lorp';

interface AddressDisplayProps {
  address: ContactDetailsFormProps;
}

export const AddressDisplay = ({ address }: AddressDisplayProps) => {
  const { addressLine1, addressLine2, city, state, zipCode } = address;

  return (
    <div
      className="sui-grid sui-grid-cols-1"
      data-automation-id="delivery-address-display"
      data-qm-mask
    >
      <Typography variant="body-base">{addressLine1}</Typography>
      {addressLine2 && (
        <Typography variant="body-base">{addressLine2}</Typography>
      )}
      {(city || state || zipCode) && (
        <Typography variant="body-base">
          {city},&nbsp;{state}&nbsp;{zipCode}
        </Typography>
      )}
    </div>
  );
};
